// Reusable debounce utility for form validations
window.ValidationUtils = window.ValidationUtils || {
  timers: new Map(),
  
  debounce: function(key, callback, delay = 1500) {
    if (this.timers.has(key)) {
      clearTimeout(this.timers.get(key));
    }
    
    const timer = setTimeout(() => {
      callback();
      this.timers.delete(key);
    }, delay);
    
    this.timers.set(key, timer);
  },
  
  clearTimer: function(key) {
    if (this.timers.has(key)) {
      clearTimeout(this.timers.get(key));
      this.timers.delete(key);
    }
  },
  
  clearAllTimers: function() {
    this.timers.forEach((timer) => clearTimeout(timer));
    this.timers.clear();
  },
  
  constants: {
    PASSWORD_STRENGTH_THRESHOLD: 3,
    DEBOUNCE_DELAY: 1500,
    BLUR_DELAY: 200
  }
};